import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './components/home/home.component';
import { ProductListComponent } from './components/product-list/product-list.component';
import { ProductDetailComponent } from './components/product-detail/product-detail.component';
import { CartComponent } from './components/cart/cart.component';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { LoginComponent } from './login/login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RegisterComponent } from './register/register.component';
import { ProductFormComponent } from './components/product-form/product-form.component';
import { NavbarComponent } from './shared/navbar/navbar.component';
import { PublicHomeComponent } from './components/public-home/public-home.component';
import { CheckoutComponent } from './components/checkout/checkout.component';
import { OrderConfirmationComponent } from './components/order-confirmation/order-confirmation.component';
import { ToastComponent } from './toast/toast.component';
import { CategoryFormComponent } from './category-form/category-form.component';
import { CategoryListComponent } from './category-list/category-list.component';
import { CategoryTreeComponent } from './category-tree/category-tree.component';
import { AdminCategoriesComponent } from './admin-categories/admin-categories.component';
import { CategorySidebarComponent } from './category-sidebar/category-sidebar.component';
import { VendorProfileComponent } from './components/vendor-profile/vendor-profile.component';
import { VendorProductManagementComponent } from './components/vendor-product-management/vendor-product-management.component';
import { AdminOrderStatusComponent } from './dashboard/orders/admin-order-status.component';
import { OverviewComponent } from './dashboard/overview/overview.component';
import { AdminVendorsComponent } from './components/admin-vendors/admin-vendors.component';
import { VendorRegisterComponent } from './components/vendor-register/vendor-register.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { VendorsComponent } from './dashboard/vendors/vendors.component';
import { UsersComponent } from './users/users.component';
import { TrackingDetailsComponent } from './tracking-details/tracking-details.component';
import { OrderTrackingComponent } from './order-tracking/order-tracking.component';
import { CustomerOrdersComponent } from './customer-orders/customer-orders.component';
import { PaymentSuccessComponent } from './payment-success/payment-success.component';
import { PaymentFailedComponent } from './payment-failed/payment-failed.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    ProductListComponent,
    ProductDetailComponent,
    CartComponent,
    LoginComponent,
    RegisterComponent,
    ProductFormComponent,
    PublicHomeComponent,
    NavbarComponent,
    CheckoutComponent,
    OrderConfirmationComponent,
    ToastComponent,
    CategoryFormComponent,
    CategoryListComponent,
    CategoryTreeComponent,
    AdminCategoriesComponent,
    CategorySidebarComponent,
    VendorRegisterComponent,
    VendorProfileComponent,
    DashboardComponent,
    VendorProductManagementComponent,
    AdminVendorsComponent,
    DashboardComponent,
    AdminOrderStatusComponent,
    OverviewComponent,
    VendorsComponent,
    UsersComponent,
    TrackingDetailsComponent,
    OrderTrackingComponent,
    CustomerOrdersComponent,
    PaymentSuccessComponent,
    PaymentFailedComponent
  ],
  imports: [
    BrowserModule, HttpClientModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
